<template>
  <van-popup
    class="advertisement_-conter"
    v-model="$store.state.isRechargeGift"
    v-if="$store.state.isRechargeGift"
    z-index="2300"
  >
    <div class="advertisement_list _border">
      <div class="ZAJ3tO484KoZnr7Y6n_l">
        {{ $t('components._Bnusdeprimeirodepsito') }}
      </div>
      <div class="xmHlf3AdKNfopQZxGTk7">
        <div class="wPL4o40ajO3bGEmyjpNf">
          <div class="R57xbU1vEwuho81iaSVT-conter">
            <div class="van-row">
              <!-- -->
              <div
                style="
                  width: 100%;
                  border-radius: 0.1rem;
                  margin-bottom: 0.2rem;
                  font-size: 0.28rem;
                "
              >
                <div
                  class="flex items-center justify-between"
                  style="width: 100%; margin-bottom: 0.2rem"
                >
                  <div class="currencyAmount" style="text-align: left">
                    Tarefa de recarga para novos membros
                  </div>
                  <div class="currencyAmount flex items-center justify-center">
                    <div
                      class="flex items-center"
                      style="justify-content: end"
                      @click="getNotification"
                    >
                      <svg-icon
                        classNameQita
                        icon-class="icon-reload"
                        class="item-svg"
                        :class="{
                          animate__manimated: animate__manimated
                        }"
                        style="
                          color: #fff;
                          font-size: 0.2rem;
                          margin-left: 0.1rem;
                          vertical-align: text-bottom;
                          width: 0.28rem;
                          height: 0.28rem;
                        "
                      />
                    </div>
                    <span
                      style="
                        line-height: 1.2;
                        word-break: break-word;
                        margin-left: 0.1rem;
                      "
                      >Atualizar</span
                    >
                  </div>
                </div>

                <div class="conterms" v-for="(item, index) in formDate.list">
                  <img
                    src="../../assets/mine30/depositReward.webp"
                    alt=""
                    style="width: 0.9rem; height: 0.9rem"
                  />
                  <div
                    style="
                      color: var(--theme-text-color-lighten);
                      text-align: left;
                      margin-left: 0.1rem;
                      margin-right: 0.2rem;
                      flex-grow: 1;
                      display: flex;
                      flex-direction: column;
                      justify-content: space-between;
                      height: 100%;
                    "
                  >
                    <span
                      >{{ $t('Recharge._Firstdeposit') }} ≥ {{ item.recharge }},
                      {{ $t('_homeTile_tab._Bonus') }}
                      <span style="color: var(--theme-secondary-color-finance)">
                        {{ item.bonus }}
                      </span></span
                    >
                    <div class="nUtoDOFYqni_cq_dHUjg">
                      <div class="i9WaVhztJIXx90Q1PPLD">
                        <div class="J5dtKM_LB6fse7jhX2hk FPKXpabqN25lBr4IA7LQ">
                          <div
                            class="MtFB4D3SHXXdqKU0qelp SC6yMRCGE2upeyEdgibm"
                            :style="{
                              width: `${
                                (removeThousandSeparatorAndDecimalPoint(
                                  formDate.now_recharge
                                ) /
                                  removeThousandSeparatorAndDecimalPoint(
                                    item.recharge
                                  )) *
                                100
                              }%`
                            }"
                          ></div>
                          <span
                            class="kNDhRFHNQ398GxjnCVlg u5sLSrD0KWEulumHoUzc"
                          >
                            {{ formDate.now_recharge }}/
                            {{ item.recharge }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <van-button
                    style="width: 2.5rem"
                    @click="toRecharge"
                    :class="
                      formDate.close_recharge
                        ? 'ant-btn ant-btn-primary1 yJrr5gS3ZL4NGzZkaPXH'
                        : 'ant-btn ant-btn-primary yJrr5gS3ZL4NGzZkaPXH'
                    "
                    type="info"
                    native-type="submit"
                  >
                    {{ $t('_VIP._Depósito') }}</van-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          margin: 0.2rem 0;
          display: flex;
          justify-content: space-around;
          gap: 0.3rem;
        "
        class="orkXHvtNM5R_5twq6l5I"
      >
        <button
          type="button"
          @click="
            $router.push({ name: 'records' }),
              ($store.state.isRechargeGift = false)
          "
          class="ant-btn RRWQlUJLCPB59ggBUdFl"
        >
          {{ $t('_VIP._Histórico') }}
        </button>
        <van-button
          @click="
            $router.push({ name: 'firstRecharge' }),
              ($store.state.isRechargeGift = false)
          "
          class="ant-btn ant-btn-primary yJrr5gS3ZL4NGzZkaPXH"
          type="info"
          native-type="submit"
        >
          {{ $t('menGMen._Detalhes') }}</van-button
        >
      </div>
      <div class="login-register-from-space">
        <van-checkbox
          v-model="todayChecked"
          style="padding-bottom: 0.12rem"
          shape="square"
          checked-color="var(--theme-secondary-color-success)"
          icon-size=".32rem"
        >
          <span class="chen_texbt">{{ $t('components._hojeNovamente') }}</span>
        </van-checkbox>
        <van-checkbox
          v-model="permanentChecked"
          style="padding-bottom: 0.12rem"
          shape="square"
          checked-color="var(--theme-secondary-color-success)"
          icon-size=".32rem"
        >
          <span class="chen_texbt">{{
            $t('components._Ocultarpermanenfemente')
          }}</span>
        </van-checkbox>
      </div>
    </div>

    <div
      class=""
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.4rem;
      "
    >
      <img
        style="width: 0.5984rem; height: 0.5984rem; cursor: pointer"
        @click="cunSltenmefals"
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
      />
    </div>
  </van-popup>
</template>

<script>
import { dailySignIn, firstRecharge } from '@/apis/modules/detail.js';
import { mapState } from 'vuex';
import { Toast } from 'vant';
export default {
  // isRechargeGift
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    model: {
      type: [Object, Array],
      required: {}
    }
  },
  computed: {
    ...mapState(['first_recharge', 'config', 'marquee', 'vuex_token_head'])
  },
  data() {
    return {
      codeValue: '',
      checked: false,
      todayChecked: false,
      permanentChecked: false,
      CancelDisplay: false,
      mesnComenste: false,
      inputFocus: false,
      formDate: {}
    };
  },
  created() {
    this.getNotification();
  },
  methods: {
    toRecharge() {
      if (!this.vuex_token_head) {
        this.$store.commit('isRecord');
      } else {
        if (!this.formDate.close_recharge) {
          this.$store.commit('isDeposit', true);
        }
      }
    },
    getNotification() {
      firstRecharge({}).then(({ code, data, msg }) => {
        //404
        let { marquee } = data;
        this.formDate = data;
        //
      });
    },
    cunSltenmefals() {
      this.$store.commit('publicFun', ['isRechargeGift', false]);
      // todayChecked:false,
      // permanentChecked:false,
      if (this.permanentChecked) {
        window.localStorage.setItem('isRechargeGift', false);
      } else if (this.todayChecked) {
        window.localStorage.setItem(
          'isRechargeGiftTime',
          new Date().getTime() + 24 * 60 * 60 * 1000
        );
      }
    },
    openUelConems(jump) {
      if (jump != 'firstRecharge') return;
      this.$store.commit('publicFun', ['isRechargeGift', false]);
      this.openUrl('firstRecharge');
    }
  }
};
</script>
<style>
.login-body {
  font-weight: 400;
}

.van-popup.advertisement_-conter {
  background-color: transparent;
}

.ZaAWGnvFuhPwlBk40od_.svg-icon {
  width: 0.24rem !important;
  height: 0.24rem !important;
  color: var(--theme-label-secondary-color-finance);
  margin-left: 0.15rem;
}
</style>
<style scoped>
.smallBtn-VvG4v {
  padding: 0 0.2rem;
  height: 0.5rem;
  font-size: 0.2rem;
  border-radius: 0.14rem;
  border: 0;
  text-align: center;
  line-height: 0.5rem;
  color: var(--theme-primary-font-color);
  background-color: var(--theme-primary-color);
  border-color: var(--theme-primary-color);
  box-sizing: border-box;
  border: none;
  outline: none;
  cursor: pointer;
}
.login-register-from-space {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.login-register-from-space .chen_texbt {
  font-size: 0.23rem;
  color: var(--theme-text-color-darken);
  text-align: left;
}
.listTitle-UKWM2 {
  display: flex;
  border: 0.02rem solid var(--theme-color-line);
  height: 0.8rem;
  align-items: center;
  border-radius: 0.1rem;
  background: var(--theme-main-bg-color) !important;
  color: var(--theme-text-color-process-text);
  top: 0.2rem;
}
.listTitle-UKWM2 > h2 {
  font-size: 0.24rem;
  line-height: 1;
  flex: 1;
  text-align: center;
  font-weight: 0;
  color: var(--theme-text-color-process-text);
  word-break: break-word;
  padding: 0 0.1rem;
  line-height: 0.3rem;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.listItem-WUKaB {
  display: flex;
  min-height: 0.7rem;
  align-items: center;
  padding: 0.1rem 0;
  background-color: var(--theme-main-bg-color) !important;
  box-sizing: border-box;
  border-radius: 0.14rem;
}
.listItem-WUKaB > div:last-child {
  color: var(--theme-primary-color);
}
.listItem-WUKaB > div {
  flex: 1;
  text-align: center;
  font-size: 0.2rem;
  color: var(--cms-text-color-secondary);
}
.listItem-WUKaB:nth-child(2n) {
  background-color: var(--theme-bg-color) !important;
}
.wPL4o40ajO3bGEmyjpNf {
  background-color: var(--theme-main-bg-color);
  border-radius: 0.1rem;
  height: calc(85dvh - 3.3rem);
  overflow-y: scroll;
  padding: 0.2rem;
  padding-bottom: 0;
}
.orkXHvtNM5R_5twq6l5I > button {
  margin: 0 auto;
  border-radius: 0.1rem;
}
.orkXHvtNM5R_5twq6l5I .RRWQlUJLCPB59ggBUdFl {
  background-color: var(--theme-main-bg-color);
  border: thin solid var(--theme-primary-color);
  color: var(--theme-primary-color) !important;
  color: var(--theme-primary-font-color);
  height: 0.7rem;
  font-size: 0.26rem;
  line-height: 1.2;
  margin-right: 0;
  text-align: center;
  width: 100%;
}
.orkXHvtNM5R_5twq6l5I .yJrr5gS3ZL4NGzZkaPXH {
  color: var(--theme-primary-font-color);
  line-height: 1.2;
  text-align: center;
  width: 100%;
  height: 0.7rem;
  font-size: 0.26rem;
}

.conterms {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.24rem;
  border-radius: 0.1rem;
  padding: 0.2rem 0.2rem 0.2rem 0.1rem;
}
.conterms:nth-child(even) {
  background-color: var(--theme-bg-color);
}
.conterms div {
  box-sizing: border-box;
  text-align: center;
}
.conterms .yJrr5gS3ZL4NGzZkaPXH {
  font-size: 0.16rem;
  height: 0.6rem;
  width: 1.6rem;
  padding: 0 0.15rem;
}
.conterms .van-tag--danger {
  display: inline-block;
  box-sizing: border-box;
  min-width: 0.32rem;
  padding: 0 0.08rem;
  color: #fff;
  height: 0.26rem;
  text-align: center;
  position: absolute;
  width: 0.7rem;
  right: 1rem;
  top: -0.25rem;
  border-radius: 0.13rem 0.13rem 0.13rem 0;
  font-size: 0.18rem;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.26rem;
  letter-spacing: normal;
  overflow: visible;
  vertical-align: center;
}
.conterms .van-tag--danger:before {
  content: '';
  display: inline-block;
  position: absolute;
  bottom: -0.06rem;
  z-index: 20;
  left: 0;
  width: 0;
  height: 0;
  border-left: 0.079rem solid #ee0a24;
  border-top: 0.066rem solid transparent;
  border-bottom: 0.066rem solid transparent;
  font-size: 0;
}
.R57xbU1vEwuho81iaSVT-conter {
  font-size: 0.2rem;
}
.R57xbU1vEwuho81iaSVT-conter .ant-col {
  -ms-flex-align: center;
  align-items: center;
  color: var(--theme-text-color-darken);
  display: -ms-flexbox;
  display: flex;
}

.R57xbU1vEwuho81iaSVT-conter .van-row {
  justify-content: center;
  display: flex;
  align-items: center;
}

.R57xbU1vEwuho81iaSVT-conter .van-col {
  margin-bottom: 0.2rem;
}

.R57xbU1vEwuho81iaSVT-conter .van-col label {
  color: var(--theme-text-color-lighten);
  margin-right: 0.1rem;
}

.R57xbU1vEwuho81iaSVT-conter .currencyAmount {
  color: var(--theme-text-color-darken);
  max-width: 50%;
}
.R57xbU1vEwuho81iaSVT-conter .yellow {
  color: var(--theme-secondary-color-finance);
}
.R57xbU1vEwuho81iaSVT-conter .red {
  color: var(--theme-secondary-color-error);
}

.nUtoDOFYqni_cq_dHUjg {
  align-items: center;
  display: grid;
  font-size: 0.18rem;
  margin-top: 0.2rem;
}

.nUtoDOFYqni_cq_dHUjg .FPKXpabqN25lBr4IA7LQ {
  background-color: rgba(0, 0, 0, 0.08);
  border-bottom: 0.01rem solid hsla(0, 0%, 100%, 0.5);
  border-radius: 0.1rem;
  height: 0.2rem;
}

.nUtoDOFYqni_cq_dHUjg .SC6yMRCGE2upeyEdgibm {
  background-color: var(--theme-secondary-color-success);
  border-radius: 0.1rem;
}

.nUtoDOFYqni_cq_dHUjg .u5sLSrD0KWEulumHoUzc {
  color: #fff;
  line-height: 0.2rem;
}

.nUtoDOFYqni_cq_dHUjg .i9WaVhztJIXx90Q1PPLD {
  display: flex;

  align-items: center;
}

.J5dtKM_LB6fse7jhX2hk {
  overflow: hidden;
  position: relative;
  width: 100%;
}

.J5dtKM_LB6fse7jhX2hk.QF3VjOqeGp_QDYsZS4Ei {
  overflow: visible;
  text-align: center;
}

.J5dtKM_LB6fse7jhX2hk .MtFB4D3SHXXdqKU0qelp {
  height: 100%;
  left: 0;
  position: absolute;
}

.J5dtKM_LB6fse7jhX2hk .kNDhRFHNQ398GxjnCVlg {
  position: absolute;
  text-align: center;
  top: 0;
  left: 0;
  width: 100%;
}

.J5dtKM_LB6fse7jhX2hk .YumY578c3s4HnIJXRiBw i {
  color: var(--theme-primary-font-color);
  font-size: 0.22rem;
}

.van-button--primaryui-button--success {
  background-color: var(--theme-disabled-bg-color);
  border-color: var(--theme-disabled-bg-color);
  color: var(--theme-disabled-font-color);
}

._sign-item0_zocom_39 ._reward-pattern_zocom_54 {
  margin-top: 0;
}

._sign-item0_zocom_39 ._caption_zocom_135 {
  height: 0.55rem !important;
}

._sign-item0_zocom_39 .sign-badge,
._sign-item6_zocom_158 .sign-badge {
  left: auto;
  right: -0.15rem;
}

._item_zocom_17._sign-item0_zocom_39:nth-child(3n) {
  margin-right: 0;
}

._item_zocom_17 .sign-badge {
  position: absolute;
  top: 0;
  left: 50%;
  transform: none;
  right: auto;
  max-width: inherit !important;
  color: #ff0;
}

._item_zocom_17 ._reward-pattern_zocom_54 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.24rem;
  height: 1.24rem;
  margin: 0.2rem auto 0;
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .bg-receive {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 1.24rem;
  transform: translate(-50%, -50%);
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive {
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 0.5rem;
  margin-top: 0.02rem;
  font-weight: 700;
  font-size: 0.22rem;
  line-height: 0.24rem;
  text-align: center;
  transform: scale(0.7) rotate(-18deg);
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive .text {
  position: relative;
  top: 0;
  display: grid;
  line-height: 0;
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive:lang(zh) {
  font-size: 0.32rem;
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive:lang(en) {
  font-size: 0.32rem;
}

._item_zocom_17 ._reward-pattern_zocom_54 .received-box .has-receive:lang(pt) {
  font-size: 0.26rem;
}

._item_zocom_17 ._reward-pattern_zocom_54 .picture {
  display: block;
  width: 100%;
  height: 100%;
}

._item_zocom_17 ._reward-description_zocom_113 {
  margin-bottom: 0.01rem;
  padding: 0.01rem 0.1rem;
}

._item_zocom_17 ._reward-description_zocom_113 .divider {
  border-top: 0.01rem solid var(--theme-text-color);
}

._item_zocom_17 ._reward-description_zocom_113 .text-wrap {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  width: 100%;
  height: 0.3rem;
  margin-bottom: 0.2rem;
  font-size: 0.22rem;
  line-height: 0.3rem;
  text-align: center;
}

._item_zocom_17 ._reward-description_zocom_113 .yellow {
  color: var(--skin__accent_3);
}

._item_zocom_17 ._caption_zocom_135 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0.4rem;
  padding-top: 0;
  color: var(--skin__neutral_2);
  font-size: 0.24rem;
  line-height: 1.29;
}

._item_zocom_17 ._caption_zocom_135 ._sign-btn_zocom_145 {
  width: 1.2rem;
  height: 0.4rem;
  font-size: 0.18rem;
  border-radius: 0.1rem;
  padding: 0 0.05rem;
}

._item_zocom_17
  ._caption_zocom_135
  ._sign-btn_zocom_145
  :not(:lang(zh))
  .ui-button__text {
  word-break: break-word;
}

.G9JHenpYWEhrwkyqb33R {
  -ms-flex-align: center;
  -ms-flex-pack: justify;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.xmHlf3AdKNfopQZxGTk7 {
  text-align: left;
  color: var(--theme-disabled-font-color);
  font-size: 0.24rem;
}

html .ant-btn.ant-btn-primary {
  /* width: 5rem; */
  font-size: 0.24rem;
  background-color: var(--theme-primary-color);
  border-color: var(--theme-primary-color);
  margin-top: 0;
  display: flex;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  justify-content: center;
}

html .ant-btn.ant-btn-primary {
  color: var(--theme-primary-font-color);
  text-shadow: none;
  height: 0.7rem;
  border-radius: 0.14rem;
}

.ZAJ3tO484KoZnr7Y6n_l {
  color: var(--theme-text-color-darken);
  font-size: 0.3rem;
  padding: 0.2rem 0.3rem;
  font-weight: 400;
}

.RlMZ1IA0k4zaYVTGjIiN {
  color: var(--theme-text-color-darken);
  font-size: 0.22rem;
  margin-bottom: 0.4rem;
  margin-top: 0.3rem;
  min-height: 0.7rem;
}

.advertisement_list {
  width: 7.1rem;
  height: 85dvh;
  padding: 0.2rem;
  box-sizing: border-box;
  text-align: center;
  background-color: var(--theme-bg-color);
  border-radius: 0.2rem;
}

.advertisement_list .title {
  /* color: var(--theme-label-secondary-color-finance); */
  text-align: center;
  line-height: 1rem;
  font-size: 0.4rem;
}

._common-tabs-content {
  max-height: 5.4rem;
  width: 100%;
}

.consliTst {
  display: flex;
  align-items: center;
  border-radius: 0.1rem;
  height: 0.8rem !important;
  background-color: rgba(var(--theme-primay-color-hex), 0.05);
  max-width: 2.05rem;
  padding: 0.15rem;
  text-align: revert !important;
}

.consliTst svg {
  width: 0.38rem;
  height: 0.38rem;
  color: var(--theme-primary-color);
  margin-right: 0.08rem;
}

.consliTst span {
  font-size: 0.22rem;
  display: inline-block;
  line-height: 0.28rem;
  flex: 1;
  color: var(--theme-primary-color);
  overflow: hidden;
  text-overflow: ellipsis;
  /* white-space: nowrap; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  white-space: break-spaces !important;
}

.ant-btn.ant-btn-primary1 {
  background-color: var(--theme-disabled-bg-color);
  border-color: var(--theme-disabled-bg-color);
  color: var(--theme-disabled-font-color);
}
.ant-btn.ant-btn-primary {
  background-color: var(--theme-primary-color);
  border-color: var(--theme-primary-color);
}
</style>
